import React from 'react';

import {
  InputLabel
} from 'components/form/prototypes';

const OriginalWarehouse = () => {

  const isDisabled = true;

  return (
    <InputLabel
      name='ncr.original_warehouse'
      label='Original Shipping Warehouse'
      disabled={isDisabled} />
  )
}

export { OriginalWarehouse };
